import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: var(--color-surface-1);
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 0.8rem;
  color: var(--color-accent);
`;

interface IProps {
  value: number;
  style?: React.CSSProperties;
}

export const Count = (props: IProps): React.ReactElement => {
  return <Container>{props.value}</Container>;
};
